import { gql } from '__generated__';

export default gql(`
  mutation ExportPurchases($input: ExportPurchasesInput!) {
    exportPurchases(input: $input) {
      id
    }
  }
`);
